exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-intro[data-v-01bd8ada] {\n  margin: 0;\n  padding-bottom: 2rem;\n}\n.edit-logout[data-v-01bd8ada] {\n  text-decoration: underline;\n}", ""]);

// exports
